import Vue from "vue";

/*
 * Avisos del panel ("toasts"). Estado reactivo compartido: cualquier componente
 * llama a notificar() y <db-toaster> (en Dashboard.vue) los pinta.
 *
 * No se usan los toasts de BootstrapVue porque con el CSS de Bootstrap 5 quedan
 * ocultos (.toast:not(.show) { display: none }).
 */

const DURACION = { success: 4000, info: 5000, warning: 7000, danger: 9000 };
const MAX_VISIBLES = 5;

export const estadoNotificaciones = Vue.observable({ lista: [] });

let siguienteId = 1;
const temporizadores = {};

export function cerrarNotificacion(id) {
  clearTimeout(temporizadores[id]);
  delete temporizadores[id];
  estadoNotificaciones.lista = estadoNotificaciones.lista.filter((n) => n.id !== id);
}

/**
 * @param {Object} opciones
 * @param {"success"|"danger"|"warning"|"info"} opciones.tipo
 * @param {string} opciones.mensaje
 * @param {string} [opciones.titulo]
 * @param {string[]} [opciones.detalles] líneas extra (p. ej. errores de validación)
 * @param {number} [opciones.duracion] ms; 0 = no se cierra sola
 */
export function notificar({ tipo = "success", mensaje, titulo, detalles = [], duracion } = {}) {
  if (!mensaje) return null;

  // Evita duplicados idénticos seguidos (p. ej. varias peticiones que fallan igual)
  const repetida = estadoNotificaciones.lista.find((n) => n.tipo === tipo && n.mensaje === mensaje);
  if (repetida) {
    repetida.veces += 1;
    programarCierre(repetida.id, duracion ?? DURACION[tipo] ?? 5000);
    return repetida.id;
  }

  const id = siguienteId++;
  estadoNotificaciones.lista.push({ id, tipo, mensaje, titulo, detalles, veces: 1 });

  while (estadoNotificaciones.lista.length > MAX_VISIBLES) {
    cerrarNotificacion(estadoNotificaciones.lista[0].id);
  }

  programarCierre(id, duracion ?? DURACION[tipo] ?? 5000);
  return id;
}

function programarCierre(id, ms) {
  clearTimeout(temporizadores[id]);
  if (ms > 0) temporizadores[id] = setTimeout(() => cerrarNotificacion(id), ms);
}

// Pausa/reanuda el cierre automático mientras el ratón está encima
export function pausarNotificacion(id) {
  clearTimeout(temporizadores[id]);
}

export function reanudarNotificacion(id) {
  const n = estadoNotificaciones.lista.find((x) => x.id === id);
  if (n) programarCierre(id, 3000);
}
